import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, MapPinIcon } from 'lucide-react';
import { neighborhoods } from '../data/neighborhoods';
import { useLanguage } from '../contexts/LanguageContext';
export function AreasSection() {
  const {
    t
  } = useLanguage();
  return <section id="areas" className="w-full bg-sand py-20 lg:py-28" data-id="element-11" data-mp="2bfxhclcj91sq">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-12" data-mp="2be2toz9vmvky">
        <div className="max-w-2xl" data-id="element-13" data-mp="2ge7bqtqfnyda">
          <h2 className="font-display text-3xl font-black tracking-tight text-forest sm:text-4xl lg:text-5xl" data-id="element-14" data-mp="2gd5z4ktrr3tg">
            {t.areas.title}
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-neutral-600" data-id="element-15" data-mp="2q4tli7bgxuo2">
            {t.areas.intro}
          </p>
        </div>

        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-16" data-mp="2u65f0nxgr01j">
          {neighborhoods.map(neighborhood => <li key={neighborhood.slug} data-id="element-17" data-mp="2z3ng5s58oayz">
              <Link to={`/${neighborhood.slug}`} className="group flex h-full items-center justify-between gap-4 rounded-lg border border-neutral-200 bg-white p-6 transition-[border-color,transform] duration-200 ease-out hover:-translate-y-1 hover:border-rust" data-id="element-18" data-mp="3441nf7z0ngvy">
                <span className="flex items-center gap-3" data-id="element-19" data-mp="31wqji8aimcaa">
                  <MapPinIcon className="h-5 w-5 shrink-0 text-rust" aria-hidden="true" data-id="element-20" data-mp="2wwm28g1s9dj0" />
                  <span className="font-display text-base font-bold text-forest" data-id="element-21" data-mp="3tllb9xa6yjc9">
                    {t.areas.linkTemplate.replace('{n}', neighborhood.name)}
                  </span>
                </span>
                <ArrowRightIcon className="h-4 w-4 shrink-0 text-rust transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-22" data-mp="3kt05rivkm95d" />
              </Link>
            </li>)}
        </ul>
      </div>
    </section>;
}